"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvoiceDataClient = void 0;
const base_client_1 = require("@deliverr/base-client");
const Logger_1 = require("@deliverr/commons-logs/lib/Logger");
const INVOICE_DATA_SERVICE_URL = process.env.INVOICE_DATA_SERVICE_URL;
class InvoiceDataClient extends base_client_1.ApiTokenClient {
    constructor(url = INVOICE_DATA_SERVICE_URL, accessToken) {
        super({ baseURL: `${url}`, token: accessToken });
        if (!INVOICE_DATA_SERVICE_URL) {
            Logger_1.log.warn("INVOICE_DATA_SERVICE_URL is not set");
        }
    }
    async getCarrierShippingActuals({ startDate, endDate }, carrier, shipmentIds) {
        return this.get("/billing-data/v1/carrier-packages", {
            startDate,
            endDate,
            carrier,
            shipmentIds,
        });
    }
}
exports.InvoiceDataClient = InvoiceDataClient;
//# sourceMappingURL=InvoiceDataClient.js.map